import { later } from '@ember/runloop';
export function focus(input) {
  if (!input) {
    return;
  }
  setTimeout(() => {
    setInputTabIndex(input, '-1');
    later(() => input.focus());
    setInputTabIndex(input, '0');
  }, 50);
}
export function setInputTabIndex(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('tabindex', value);
}
export function setInputAutocomplete(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('autocomplete', value);
}
export function setInputEnterListener(input, callback) {
  if (!input) {
    return;
  }
  input.addEventListener('keydown', ({
    key
  }) => key === 'Enter' ? callback() : undefined);
}
export function setInputEnterKeyHint(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('enterKeyHint', value);
}